export const LOCATION_NAME_REQUIRED_MESSAGE = 'Location name is required.';

/** True when a non-empty location name is present. */
export function isLocationNameSet(locationName) {
  return Boolean(locationName?.trim());
}

/**
 * Resolves the location name from a form entity (nested location and/or top-level).
 */
export function getEntityLocationName(entity) {
  return (
    entity?.location?.locationName?.trim() || entity?.locationName?.trim() || ''
  );
}

/**
 * Location object shape expected by POST /admin/festival.
 * Omits ids when not yet assigned; address fields are null when unset.
 */
export function buildFestivalLocationPayload(
  workspaceLocation,
  locationName,
  festivalOrgId,
) {
  const loc = workspaceLocation ?? {};
  const trimmedName = locationName?.trim() ?? '';

  const payload = {
    locationName: trimmedName,
    latitude: Number(loc.latitude),
    longitude: Number(loc.longitude),
    streetAddress: loc.streetAddress ?? null,
    city: loc.city ?? null,
    state: loc.state ?? null,
    zipcode: loc.zipcode ?? null,
    radius: loc.radius ?? 1000,
  };

  const orgId = loc.orgId ?? festivalOrgId;
  if (orgId != null && Number(orgId) > 0) {
    payload.orgId = Number(orgId);
  }

  const locationId = loc.locationId;
  if (locationId != null && Number(locationId) > 0) {
    payload.locationId = Number(locationId);
  }

  return payload;
}
